// ─── Subject accent colours, shared across SAT/GRE quiz, full-test, and score dashboard ─
export const SUBJECT_STYLE = {
  'Reading & Writing': { gradient: 'linear-gradient(135deg,#198754,#20c997)', badge: '#198754' },
  'Mathematics':       { gradient: 'linear-gradient(135deg,#003D8F,#0d6efd)', badge: '#003D8F' },
  'Verbal Reasoning':       { gradient: 'linear-gradient(135deg,#6f42c1,#a370f7)', badge: '#6f42c1' },
  'Quantitative Reasoning': { gradient: 'linear-gradient(135deg,#0d6efd,#4dabf7)', badge: '#0d6efd' },
  'Analytical Writing':     { gradient: 'linear-gradient(135deg,#d63384,#f783ac)', badge: '#d63384' },

  // GATE DA subjects
  'General Aptitude':                    { gradient: 'linear-gradient(135deg,#fd7e14,#ffc107)', badge: '#fd7e14' },
  'Engineering Mathematics':              { gradient: 'linear-gradient(135deg,#0d6efd,#4dabf7)', badge: '#0d6efd' },
  'Programming & Data Structures':        { gradient: 'linear-gradient(135deg,#6610f2,#8540f5)', badge: '#6610f2' },
  'Database Management & Warehousing':    { gradient: 'linear-gradient(135deg,#20c997,#0dcaf0)', badge: '#20c997' },
  'Machine Learning':                     { gradient: 'linear-gradient(135deg,#d63384,#f783ac)', badge: '#d63384' },
  'Artificial Intelligence':              { gradient: 'linear-gradient(135deg,#198754,#20c997)', badge: '#198754' },
}
